import { default as React, useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import { images } from '../../../assets'

const settings = {
  arrows: false,
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1
}
const settings2 = {
  arrows: false,
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 1
}

const PhoneArea = ({ nav2, setNav1 }) => (
  <div className="contents phone-area" style={{ opacity: 0, transform: 'translateY(-50px)' }}>
    <div className="phone-confetti">
      <img src={images.phone_confeti} alt={images.phone_confeti} />
    </div>
    <div className="logo_square">
      <img src={images.logo_square_svg} alt={images.logo_square_svg} />
    </div>
    <div className="contents_slide">
      <div className="slide_wrap phone-area--slide_wrap">
        <Slider asNavFor={nav2} ref={slider1 => setNav1(slider1)} {...settings} className="slide">
          <div>
            <img src={images.img_intro1_1} alt={images.img_intro1_1} />
          </div>
          <div>
            <img src={images.img_intro1_2} alt={images.img_intro1_2} />
          </div>
          <div>
            <img src={images.img_intro1_3} alt={images.img_intro1_3} />
          </div>
          <div>
            <img src={images.img_intro1_4} alt={images.img_intro1_4} />
          </div>
        </Slider>
      </div>
    </div>
  </div>
)

const IntroArea = ({ nav1, setNav2 }) => {
  return (
    <div className="contents intro-area" style={{ opacity: 0, transform: 'translateY(-50px)' }}>
      <div className="intro-area-tit-box">
        <div className="intro-area-tag">신규</div>
        <div className="intro-area-tit">스폰지 사장님 앱이 출시되었어요.</div>
      </div>
      <div className="contents_slide">
        <div className="slide_wrap">
          <Slider asNavFor={nav1} ref={slider2 => setNav2(slider2)} {...settings2} className="slide">
            <div>
              언제 어디서나 <br />
              흩어져 있는 배달앱의
              <br />
              리뷰들을 한 곳에서
            </div>
            <div>
              관심 리뷰 확인,
              <br />
              추천 댓글 수정 및<br />
              등록까지 손쉽게
            </div>
            <div>
              추가 댓글로 매장의 <br />
              이벤트 및 안내를
              <br />
              편리하게
            </div>
            <div>
              매월 발행되는 <br />
              월간 리포트로 <br />
              효율적인 평점 관리
            </div>
          </Slider>
        </div>
        <div className="store-btns">
          <a className="store-btn" 
            href="https://play.google.com/store/apps/details?id=com.sponge.prod">
            <img src={images.google_play} alt="Google Play" />
            구글플레이 다운로드
          </a>
          <a
            className="store-btn"
            rel="noreferrer"
            href="https://apps.apple.com/us/app/%EC%8A%A4%ED%8F%B0%EC%A7%80-%EC%82%AC%EC%9E%A5%EB%8B%98/id6504112652"
            target="_blank">
            <img src={images.apple} alt="App Store" />
            앱스토어 다운로드
          </a>
        </div>
      </div>
    </div>
  )
}

export const Intro1 = () => {
  const [nav1, setNav1] = useState()
  const [nav2, setNav2] = useState()

  return (
    <div className="section" id="intro1">
      <div className="contents_wrap">
        <div className="intro-slide">
          <PhoneArea nav1={nav1} setNav1={setNav1} nav2={nav2} setNav2={setNav2} />
          <IntroArea nav1={nav1} setNav1={setNav1} nav2={nav2} setNav2={setNav2} />
        </div>
      </div>
    </div>
  )
}
